import React from 'react';
import { Separator } from './ui/separator';

const Ecosystem = () => {
  return (
    <section className="py-12 md:py-16 max-w-2xl mx-auto">
      <Separator className="mb-12 md:mb-16 bg-border" />
      
      <h2 className="font-serif text-3xl md:text-4xl font-medium text-foreground mb-4">
        Ecosystem
      </h2>
      
      <p className="font-sans text-base md:text-lg text-foreground/70 mb-12">
        I’m interested in high-leverage collaborations where technical depth meets market-moving vision.
      </p>
      
      <div className="space-y-12">
        {/* For VCs & Investors - Ahora sos el Founder, no el que hace el Due Diligence para otros */}
        <div className="group border-l border-foreground/10 pl-6 hover:border-foreground/40 transition-colors">
          <h3 className="font-serif text-xl md:text-2xl font-medium text-foreground mb-3">
            Partners & Investors
          </h3>
          <p className="font-sans text-base text-foreground/80 leading-relaxed">
            I am currently scaling <span className="font-semibold text-foreground text-primary">enabl.ai</span>. I’m open to connecting with institutional partners and strategic angels who understand the infrastructure play behind the global talent market and the shift toward AI-driven automated operations.
          </p>
        </div>
        
        {/* For Founders - Enfocado en gente de tu nivel */}
        <div className="group border-l border-foreground/10 pl-6 hover:border-foreground/40 transition-colors">
          <h3 className="font-serif text-xl md:text-2xl font-medium text-foreground mb-3">
            Founders & Entrepreneurs
          </h3>
          <p className="font-sans text-base text-foreground/80 leading-relaxed">
            I enjoy stress-testing architectures and scaling models. If you are navigating the transition from a service-based model to a product-led organization, or fighting the <span className="italic text-foreground/90">Noise Crisis</span> in your own industry, let’s exchange notes.
          </p>
        </div>
        
        {/* For Developers - Filtrando por calidad/signal */}
        <div className="group border-l border-foreground/10 pl-6 hover:border-foreground/40 transition-colors">
          <h3 className="font-serif text-xl md:text-2xl font-medium text-foreground mb-3">
            Engineers & Architects
          </h3>
          <p className="font-sans text-base text-foreground/80 leading-relaxed">
            Through <span className="font-semibold text-foreground"><a href="https://enabl.ai" target="_blank" rel="noopener noreferrer">Enabl</a></span>, we are building the intelligent firewall for the tech world. We are looking for "Signal" in a world of "Noise". If you value technical precision over volume, let's talk.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Ecosystem;